// extracted by mini-css-extract-plugin
export var editInput = "_fh-0";
export var editInputCompact = "_fh-2";
export var editInputLarge = "_fh-1";
export var editInputSmall = "_fh-3";